import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, InputWithLabel, Switch, Text } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import { MAX_RETURN_CANCEL_DEADLINE_DAYS } from '../constants'
import * as Styles from './styles'

const ReturnCancelDeadLine = ({
  returnCancelDeadLine,
  setReturnCancelDeadLine,
  allowedPreferences,
  allowReturnCancelDeadline,
  onChangeAllowReturnCancelDeadline,
  disabled,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const onCheckCancelDeadLine = e => {
    const checked = e.target.checked
    onChangeAllowReturnCancelDeadline(checked)

    if (checked) {
      setReturnCancelDeadLine(1)
    } else {
      setReturnCancelDeadLine(null)
    }
  }

  const getError = () => {
    if (returnCancelDeadLine < 1 || returnCancelDeadLine > MAX_RETURN_CANCEL_DEADLINE_DAYS) {
      return t('El plazo debe encontrarse entre un mínimo de 1 días y un máximo de 60')
    }
  }

  if (!allowedPreferences.includes(preferences.returnCancelDeadlineDays)) return null

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Cancelación automática')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Si habilitas la cancelación automática, las transacciones no instantáneas en estado "En proceso", pasarán a estado "Cancelado" automáticamente en el plazo que definas (entre 1 y 60 días).'
        )}
      </Text>
      <Styles.MainContainer isActive={allowReturnCancelDeadline}>
        <Switch
          checked={allowReturnCancelDeadline}
          onChange={onCheckCancelDeadLine}
          label={<Text type="titleS">{t('Habilitar cancelación automática')}</Text>}
          disabled={disabled}
        />
        {allowReturnCancelDeadline && (
          <>
            <Alert type="warning">{t('El plazo debe encontrarse entre un mínimo de 1 días y un máximo de 60')}</Alert>
            <InputWithLabel
              value={returnCancelDeadLine}
              label={t('Días')}
              fullWidth
              type="number"
              backgroundColor={theme.colors.background.primary}
              error={getError()}
              helperText={getError()}
              onChange={e => setReturnCancelDeadLine(e.target.value)}
              disabled={disabled}
            />
          </>
        )}
      </Styles.MainContainer>
    </>
  )
}

export default ReturnCancelDeadLine
